import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'wave-saw-tool', 'WaveSawTool', [["path",{"d":"M3 12h5l4 8v-16l4 8h5"}]]);